"use client";

import type { UseOpenApiMutationOptions } from "@packages/sdk";
import { useOpenApiMutation } from "@packages/sdk";

const urlBackendPath = "/login/related-accounts/{userId}" as const;

export const useRequestLoginRelatedAccountsPost = (
  props: Partial<UseOpenApiMutationOptions<typeof urlBackendPath, "POST">> = {},
) =>
  useOpenApiMutation({
    method: "POST",
    urlBackendPath,
    meta: { suppressErrorToast: true },
    ...props,
  });
